// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectBuiltinFittingQueryResult, selectBuiltinFittingsPageLoading, selectBuiltinFittingsShowInitWaitingMessage} from '../_selectors/builtin-fitting.selectors';

export class BuiltinFittingsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectBuiltinFittingsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectBuiltinFittingsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectBuiltinFittingQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
